import ExtendableError from '@mmw/error';

// eslint-disable-next-line import/prefer-default-export
export class NotConfiguredServiceError extends ExtendableError {}
